import {withRouter} from "react-router";
import React, {useEffect, useMemo, useState} from "react";
import DemandService from 'services/DemandService';
import querystring from "querystring";
import {connect} from "react-redux";
import Loading from 'components/Loading';
import MainForm from "./MainForm";
import MainFormExPost from "./MainFormExPost";
import HeaderService from "services/HeaderService";
import Confirm from "components/popup/confirm/Confirm";
import {setFormDraftLoaded} from "redux/actions";

function MainFormWrapper(
    {
        match,
        location,
        data,
        setFormDraftLoaded
    }) {
    const demandId = match.params.id;
    const search = location.search.slice(1);
    const urlParams = useMemo(() => querystring.parse(search), [search]);
    const [draftConfirm, setDraftConfirm] = useState(false);
    const [working, setWorking] = useState(false);

    useEffect(() => {
        if (demandId) {
            DemandService.get(demandId, urlParams).then(res => {
                if (res.autoSaveFormDraftEnabled) {
                    if (!!res.demand.exPost)
                        DemandService.checkForDraftExPost(res.demand.identity).then(res => setDraftConfirm(res.result));
                    else
                        DemandService.checkForDraft(res.demand.identity).then(res => setDraftConfirm(res.result));
                }
            });
        } else {
            DemandService.getCreateNew(urlParams);
            HeaderService.get(demandId);
        }

        return () => {
            DemandService.clearResources(DemandService.DEMAND_RESOURCE_ID);
            DemandService.clearResources(DemandService.DEMAND_AVAILABLE_REALIZATIONS_RESOURCE_ID);
            DemandService.clearResources(DemandService.DEMAND_AVAILABLE_ORGANIZATIONS_RESOURCE_ID);
            DemandService.clearResources(DemandService.DEMAND_AVAILABLE_FORM_TYPES_RESOURCE_ID);
            DemandService.clearResources(DemandService.DEMAND_NUMBER_AUTOMATED);
            DemandService.clearResources(DemandService.DEMAND_CASE_CLASSIFICATION_SYMBOL_REQUIRED);
        }
    }, [demandId, urlParams]);

    const loadDemandDraft = (exPost) => {
        setDraftConfirm(false);
        setWorking(true);
        if (exPost)
            DemandService.loadDraftExPost(demandId).then(res => setFormDraftLoaded('mp_1_demand', res.success));
        else
            DemandService.loadDraft(demandId).then(res => setFormDraftLoaded('mp_1_demand', res.success));
        setWorking(false);
    }

    if (!data || working) {
        return <Loading/>
    } else if (data.exPost) {
        return <>
            <MainFormExPost/>
            <Confirm
                open={draftConfirm}
                onConfirm={() => loadDemandDraft(true)}
                onCancel={() => setDraftConfirm(false)}
                confirmText="form_draft_load_confirm_text"
                confirmTitle="form_draft_load_confirm_title"
            />
        </>
    } else {
        return <>
            <MainForm/>
            <Confirm
                open={draftConfirm}
                onConfirm={() => loadDemandDraft(false)}
                onCancel={() => setDraftConfirm(false)}
                confirmText="form_draft_load_confirm_text"
                confirmTitle="form_draft_load_confirm_title"
            />
        </>
    }
}

export default connect((state) => ({
    data: state.resources.demand,
}), {setFormDraftLoaded})(withRouter(MainFormWrapper));
